import styled from 'styled-components';
import device from '../../../components/mediaQueries';

const Wrapper = styled.div`
  position: fixed;
  z-index: 5;
  border: 1px solid #eceeef;
  background-color: #eceeef;
  width: 100%;

  ${device.desktop`
    top: 165px;
  `}
  ${device.mobile`
    top: 50px;
  `}
  text-align: center;
`;

export default Wrapper;
